import Vue from 'vue'
import {Mutation, Action, VuexModule, getModule, Module} from "vuex-module-decorators";
import store from "../store";
import {CmsApiClient} from "@/_global/api_clients/CmsApiClient";


// 画像情報を格納する
export enum IMAGE_TYPES {
    BADGE = 'badge'
}

@Module({
    name: "ImagesStore",
    dynamic: true,
    store: store,
    namespaced: true
})
class ImagesStore extends VuexModule {
    // state
    private _apiResponse: CMS.Image[] = [];
    private _imageById: { [imageId: number]: CMS.Image } = {};

    // getter
    get all(): CMS.Image[] {
        return this._apiResponse || [];
    }

    get imageById() {
        return this._imageById || {};
    }

    @Action
    public async init() {
        const response: CMS.Image[] = await CmsApiClient.getImages() || [];
        this.refresh(response);
    }

    @Action
    private refresh(response: CMS.Image[]) {
        this.initVals();
        this.setResponse(response);
        for (let i = 0; i < response.length; i++) {
            this.setImageById(response[i]);
        }
    }

    @Mutation
    private initVals() {
        this._apiResponse = [];
        this._imageById = {};
    }

    @Mutation
    private setResponse(response: CMS.Image[]) {
        this._apiResponse = response;
    }

    @Mutation
    private setImageById(image: CMS.Image) {
        Vue.set(this._imageById, image.id, image);
    }

    @Action
    public async create(image: CMS.Image) {
        const added = this._apiResponse.concat([image]);
        this.refresh(added);
        await CmsApiClient.createImage(image);
        this.init();
    }

    @Action
    public async edit(image: CMS.Image) {
        const edited = this._apiResponse.map(v => (v.id == image.id) ? image : v);
        this.refresh(edited);
        await CmsApiClient.editImage(image);
        this.init();
    }

    @Action
    public async delete(imageId: number) {
        const target = this.imageById[imageId];
        const deleted = this._apiResponse.filter(v => v.id != imageId);
        this.refresh(deleted);
        await CmsApiClient.deleteImage(target);
        this.init();
    }

}

export default getModule(ImagesStore);
